import Vue from 'vue';
import { AbstractModel } from '.';

class model extends AbstractModel {
    endpoint = 'quest-pdf';

    getDownloadPdfUrl(fileName) {
        return `${Vue.$explorer.getBaseUrl()}/quest-pdf/${fileName}`;
    }
}

export const QuestPdfModel = new model();
